import React from 'react';

import { DropdownMenuType } from 'ui-components/components/dropdown-menu/dropdown-menu-type';

import { CSWFieldId, getOrderDetailsFieldId } from '../../../../../constants/field-ids';
import ConfirmationOptionContainer from '../../../../../fulfillment-planner/confirmation-option/container';
import { ConfirmationLabel } from '../../../shared-field-labels/shared-field-labels';
import LabeledField from '../labeled-field';

const fieldId = getOrderDetailsFieldId(CSWFieldId.Confirmation);

const Confirmation = () => {
  return (
    <LabeledField label={ConfirmationLabel} labelFor={fieldId}>
      <ConfirmationOptionContainer dropdownMenuType={DropdownMenuType.ComboBox} id={fieldId} />
    </LabeledField>
  );
};

export default Confirmation;
